// Notifications (45-B / 46-A, package PW; KONTRAKTY 2026-09-24): the /powiadomienia screen, the bell,
// the e-mail switches in Settings. `kind.<kind>` sentences are built ONLY from the row's payload;
// the same sentences (gettext) carry the e-mails from `app/translations`. PL and EN keys together.
export const appNotifications = {
  title: 'Notifications',
  empty: 'No notifications',
  unread: 'new',
  emailTag: 'email',
  loadMore: 'Load more',
  errorTitle: "Couldn't load notifications.",
  retry: 'Try again',
  kind: {
    own_schedule_running_out: '{handle} has posts scheduled until {date}.',
    plan_finished: 'Plan “{name}” has finished.',
    monthly_summary: 'Plays {inMonth}: {total}.',
    milestone_reached: '{threshold} plays on “{track}”.',
  },
  action: {
    own_schedule_running_out: 'Schedule',
    plan_finished: 'Show plan',
    monthly_summary: 'Show statistics',
    milestone_reached: 'Show',
  },
  month: {
    record: 'best month so far',
    topTrack: 'Top track',
    topValue: '“{track}”',
    nextRing: 'To {threshold} on “{track}”',
    left: '{left} to go',
  },
  monthVs: {
    m1: 'compared with January', m2: 'compared with February', m3: 'compared with March', m4: 'compared with April', m5: 'compared with May', m6: 'compared with June',
    m7: 'compared with July', m8: 'compared with August', m9: 'compared with September', m10: 'compared with October', m11: 'compared with November', m12: 'compared with December',
  },
  monthIn: {
    m1: 'in January', m2: 'in February', m3: 'in March', m4: 'in April', m5: 'in May', m6: 'in June',
    m7: 'in July', m8: 'in August', m9: 'in September', m10: 'in October', m11: 'in November', m12: 'in December',
  },
  today: 'today',
  yesterday: 'yesterday',
  settings: {
    heading: 'Email notifications',
    own_schedule_running_out: 'Own schedule ending',
    plan_finished: 'Plan finished',
    monthly_summary: 'Monthly summary',
    milestone_reached: 'Track milestones',
  },
}
